window.OpenBudget = {
    "data": {
        "meta": {
            "hierarchy": [
                "Funding category",
                "Category",
                "Fund"
            ],
            "page_title": "City of Philadelphia Budget",
            "description": "",
            "h1": "City of Philadelphia",
            "h2": "Budget by category",
            "data_link": "https://github.com/CityOfPhiladelphia/open-budget-data-transformer/blob/master/data/FY2014-actual.csv",
            "data_title": "Download Data",
            "uservoice": "",
            "base_headline": "Funding categories",
            "gross_cost_label": "Expenses",
            "revenue_label": "Revenues",
            "currency_prefix": "$",
            "overview_label": "Overview",
            "deficit_label": "Deficit",
            "surplus_label": "Surplus",
            "data_url": "data/phl26tagged/data.json",
            "value": {
                "label": "FY 2026",
                "type": "accounts",
                "year": "2026"
            },
            "value2": {
                "label": "FY 2025",
                "type": "accounts",
                "year": "2025"
            }
        }
    }
};

//# sourceMappingURL=2026-tagged.7c1d7f5a.js.map
